module.exports = __webpack_public_path__ + "img/energy_jiashicang.5d2651d7.png";